import QualificationDto from '@/models/Qualifications/QualificationDto';
import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import WorkerDto from '@/models/Workers/WorkerDto';
import WorkerQualificationStatus from '@/models/WorkerQualifications/WorkerQualificationStatus';

export default class WorkerQualificationDto extends BaseAgencyScopeEntityDto {
    workerId: string;
    worker: WorkerDto = new WorkerDto();
    qualificationId: string;
    qualification: QualificationDto = new QualificationDto();
    status: WorkerQualificationStatus;
}